import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 sm:pt-40 pb-20 overflow-hidden rp-noise"
    >
      {/* Decorative background */}
      <div className="absolute inset-0 rp-grid-bg opacity-70" />
      <div
        className="absolute -top-32 -right-24 w-[520px] h-[520px] rounded-full blur-3xl opacity-30 rp-anim-float"
        style={{ background: "radial-gradient(circle, #4776b9 0%, transparent 60%)" }}
      />
      <div
        className="absolute -bottom-40 -left-20 w-[480px] h-[480px] rounded-full blur-3xl opacity-25 rp-anim-float"
        style={{ background: "radial-gradient(circle, #328a57 0%, transparent 60%)", animationDelay: "1.5s" }}
      />

      <div className="rp-container relative grid lg:grid-cols-[1.15fr_0.85fr] gap-12 items-center">
        <div className="rp-reveal">
          <span className="rp-kicker rp-kicker-green">
            <Sparkles className="w-3.5 h-3.5" />
            Firma multidisciplinaria · Establecida 2008
          </span>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05]" style={{ color: "var(--rp-ink)" }}>
            Decisiones fiscales y patrimoniales que{" "}
            <span className="rp-gradient-text">resisten el tiempo</span> y la autoridad.
          </h1>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            Asesoría fiscal, patrimonial y de gobierno corporativo para empresarios, socios y familias
            empresarias mexicanas. Construimos estructuras con apego al marco legal, razón de negocio y
            soporte documental verificable.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://calendly.com/contadoresrp"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-cta-calendly"
              className="rp-btn rp-btn-primary"
            >
              Agenda tu diagnóstico
              <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="#servicios"
              data-testid="hero-cta-servicios"
              className="rp-btn rp-btn-ghost"
            >
              Conoce nuestros servicios
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-5 text-sm text-slate-500">
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[color:var(--rp-green)]" />
              Apego pleno a la normativa SAT 2026
            </div>
            <span className="hidden sm:block w-1 h-1 rounded-full bg-slate-300" />
            <div>Guadalajara · CDMX (Torre Mayor)</div>
          </div>
        </div>

        {/* Right column — decorative card stack */}
        <div className="rp-reveal relative h-[460px] lg:h-[520px]">
          <div
            className="absolute top-4 right-4 w-72 h-44 rp-card p-6 rp-glow-blue"
            style={{ transform: "rotate(3deg)" }}
          >
            <div className="text-xs uppercase tracking-widest text-slate-400">Cédula fiscal</div>
            <div className="mt-2 text-xl font-bold" style={{ color: "var(--rp-ink)" }}>
              ISR · IVA · Nómina
            </div>
            <div className="mt-3 flex items-center gap-2 text-sm text-slate-500">
              <span className="w-2 h-2 rounded-full bg-[color:var(--rp-green)] animate-pulse" />
              Entrega vía WhatsApp + correo
            </div>
            <div className="mt-4 h-1.5 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full w-3/4 bg-gradient-to-r from-[color:var(--rp-blue)] to-[color:var(--rp-green)]" />
            </div>
          </div>

          <div
            className="absolute top-44 left-2 w-80 h-52 rp-card p-6"
            style={{ transform: "rotate(-4deg)" }}
          >
            <div className="flex items-center justify-between">
              <div className="text-xs uppercase tracking-widest text-slate-400">Opinión de cumplimiento</div>
              <span className="text-[10px] font-bold px-2 py-1 rounded-full bg-emerald-50 text-emerald-700">POSITIVA</span>
            </div>
            <div className="mt-3 text-lg font-bold" style={{ color: "var(--rp-ink)" }}>
              Generada con e.firma del cliente
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-12 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-xs text-slate-400">
                  M{i}
                </div>
              ))}
            </div>
          </div>

          <div
            className="absolute bottom-4 right-8 w-64 h-32 rp-card p-5 rp-glow-green"
            style={{ transform: "rotate(2deg)" }}
          >
            <div className="text-xs uppercase tracking-widest text-slate-400">Consejería</div>
            <div className="mt-1 text-lg font-bold" style={{ color: "var(--rp-ink)" }}>
              Gobierno corporativo
            </div>
            <div className="mt-2 flex -space-x-2">
              {["#4776b9", "#328a57", "#00bfa5", "#3c3950"].map((c, i) => (
                <div
                  key={i}
                  className="w-7 h-7 rounded-full border-2 border-white"
                  style={{ background: c }}
                />
              ))}
              <div className="w-7 h-7 rounded-full border-2 border-white bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-500">
                +12
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
